import { Observable, of } from 'rxjs';
import * as i0 from "@angular/core";
var clipboardAPI = 'clipboard';
var ClipboardService = /** @class */ (function () {
    function ClipboardService() {
    }
    ClipboardService.prototype.getClipboardAPISupport = function () {
        return clipboardAPI in navigator;
    };
    ClipboardService.prototype.getClipboardAPI = function () {
        return navigator[clipboardAPI];
    };
    ClipboardService.prototype.copyToClipboard = function (val) {
        if (this.getClipboardAPISupport()) {
            var clipboard_1 = this.getClipboardAPI();
            return new Observable(function (observer) {
                clipboard_1.writeText(val)
                    .then(function () {
                    observer.next(true);
                    observer.complete();
                })
                    .catch(function (e) {
                    observer.next(false);
                    observer.complete();
                });
            });
        }
        else { // async copy unsupported
            return of(false);
        }
    };
    ClipboardService.prototype.copyInputFieldValue = function (input) {
        input.select();
        var copied = false;
        try {
            copied = document.execCommand('copy');
        }
        catch (err) {
            copied = false;
        }
        return copied;
    };
    ClipboardService.ngInjectableDef = i0.defineInjectable({ factory: function ClipboardService_Factory() { return new ClipboardService(); }, token: ClipboardService, providedIn: "root" });
    return ClipboardService;
}());
export { ClipboardService };
